import React  from 'react';
import { TextField } from '@mui/material'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const LastnameMatField = () => {
    const { handleChange } = useSavePatient();
    const { uswApeMat } = useRecoilValue(valuesFormRegisterState);
    const { uswApeMat: errorUswApeMat } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <InputLabelCustom htmlFor="input-apemat" text="Apellido materno (Opcional)" />
            <TextField
                id="input-apemat"
                size="small"
                error={errorUswApeMat && errorUswApeMat.length > 0 ? true : false}
                helperText={errorUswApeMat && errorUswApeMat.length > 0 ? `${errorUswApeMat.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswApeMat"
                type="text"
                value={uswApeMat || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder='Ej: Rodriguez'
            />
        </>
    )
}

export default LastnameMatField
